import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import styles from './Onboarding.module.css';

/** 앱을 열면 잠깐 머물렀다가 로그인으로 넘깁니다. */
export const Onboarding = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => navigate('/login'), 2000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className={styles.wrap}>
            <span className={styles.wordmark}>DOKOCREW</span>
            <span className={styles.spinner} aria-hidden />
        </div>
    );
};
